export default __webpack_public_path__ + "static/media/giftbox-2.72f14ef6.webp";